import React from 'react';
import { useConfig } from '../../ConfigContext';
import Carousel from '../Carousel/Carousel';
import { cropSlides, designSlides, OPTIONS } from '../Carousel/carouselData';

export default function PairPanel() {
  const { general, setGeneralState } = useConfig();

  return (
    <div>
      <div>
        <label className="custom-label">Hlavní text</label>
        <input
          className={`w-full p-2`}
          value={general.mainText}
          onChange={(e) => setGeneralState({ mainText: e.target.value })}
          placeholder="Zadejte hlavní text"
        />
        <div className="flex items-center gap-2 mt-1">
          <label
            htmlFor="maintext-break"
            className="custom-label inline-flex items-center me-5 cursor-pointer"
          >
            <input
              id="maintext-break"
              type="checkbox"
              className="sr-only peer"
              checked={general.mainTextBreak}
              onChange={(e) =>
                setGeneralState({ mainTextBreak: e.target.checked })
              }
            />
            <div className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-focus:ring-4 peer-focus:ring-purple-300 dark:peer-focus:ring-purple-800 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-purple-600 dark:peer-checked:bg-purple-600"></div>
            <span className="ms-3 text-md font-medium">
              Každé slovo na nový řádek
            </span>
          </label>
        </div>
      </div>
      {['normal'].includes(
        designSlides[general.selectedCarouselNameDesignIndex].name
      ) && (
        <div>
          <div className="flex items-center gap-2 mt-1">
            <label
              htmlFor="secondtext-break"
              className="custom-label inline-flex items-center me-5 cursor-pointer"
            >
              <input
                id="secondtext-break"
                type="checkbox"
                className="sr-only peer"
                checked={general.hasSecondaryText}
                onChange={(e) =>
                  setGeneralState({ hasSecondaryText: e.target.checked })
                }
              />

              <div className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-focus:ring-4 peer-focus:ring-purple-300 dark:peer-focus:ring-purple-800 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-purple-600 dark:peer-checked:bg-purple-600"></div>
              <span className="ms-3 text-md font-medium">
                Přidat další text
              </span>
            </label>
          </div>
        </div>
      )}
      <div>
        <div className="flex items-center gap-2 mt-1">
          <label
            htmlFor="orientation-checkbox"
            className="custom-label inline-flex items-center me-5 cursor-pointer"
          >
            <input
              id="orientation-checkbox"
              type="checkbox"
              className="sr-only peer"
              checked={general.orientationHorizontal}
              onChange={(e) =>
                setGeneralState({ orientationHorizontal: e.target.checked })
              }
            />
            <div className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-focus:ring-4 peer-focus:ring-purple-300 dark:peer-focus:ring-purple-800 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-purple-600 dark:peer-checked:bg-purple-600"></div>
            <span className="ms-3 text-md font-medium">
              Na výšku / na šířku
            </span>
          </label>
        </div>
      </div>
      {/* Malý text */}
      {general.hasSecondaryText && (
        <div>
          <label className="custom-label ">Datum/Text/Místo</label>
          <input
            className={`w-full p-2 rounded border ${
              general.smallTextErr ? 'border-red-500' : 'border-gray-300'
            }`}
            maxLength={20}
            value={general.secondaryText}
            onChange={(e) => setGeneralState({ secondaryText: e.target.value })}
            placeholder="Např. jméno, datum, místo…"
          />
        </div>
      )}

      <Carousel
        setter={setGeneralState}
        objKey="selectedCarouselNameDesignIndex"
        slides={designSlides}
        options={OPTIONS}
      />
      <Carousel
        setter={setGeneralState}
        objKey="selectedCarouselCropIndex"
        slides={cropSlides}
        options={OPTIONS}
      />

      {/*<div>*/}
      {/*    <div className="flex items-center gap-2 mt-1">*/}
      {/*        <label htmlFor="heart-checkbox" className="inline-flex items-center me-5 cursor-pointer custom-label">*/}
      {/*            <input*/}
      {/*                id="heart-checkbox"*/}
      {/*                type="checkbox"*/}
      {/*                checked={general.isHeart}*/}
      {/*                className="sr-only peer"*/}
      {/*                onChange={(e) => setGeneralState({isHeart: e.target.checked})}*/}
      {/*            />*/}

      {/*            <div*/}
      {/*                className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-focus:ring-4 peer-focus:ring-purple-300 dark:peer-focus:ring-purple-800 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-purple-600 dark:peer-checked:bg-purple-600"></div>*/}
      {/*            <span className="ms-3 text-md font-medium">Srdce design</span>*/}
      {/*        </label>*/}
      {/*    </div>*/}
      {/*</div>*/}
    </div>
  );
}
